module.exports = __webpack_public_path__ + "45ac510a.png";